import React, { useEffect, useState } from 'react'
import {
  alpha,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material'
import { makeStyles, TableSortLabel } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { useDispatch, useSelector } from 'react-redux'
import {
  ASSIGN_CEO,
  ASSIGN_CORPORATE_ADMIN,
  getAnnexure,
  getClientDetails,
  LINK_ANNEXURE,
  PORTFOLIO_List_NEW,
  SINGLE_ANNEXURE_DATA,
} from 'src/services/corporateService'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import SearchBar from 'material-ui-search-bar'
import formatDate from 'src/utils/commonMethods/formatDate'
import blueApprovedImg from 'src/assets/Endorsement_images/blueApproved.svg'
import ApprovedImg from 'src/assets/Endorsement_images/Group_432.svg'
import cancelImg from 'src/assets/Endorsement_images/Group_102.svg'
import BackArrow from 'src/assets/images/BackArrow.svg'
import {
  getClientId,
  getClientType,
  getClientTypeUrl,
  addScroll,
  removeScroll,
} from 'src/utils/commonMethods'
import Modal from 'src/components/common/Modal'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import AddEmployeeModal from 'src/components/ceo/EmployeeManagement/AddEmployeeModal'
import {
  DownloadRounded,
  EditRounded,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material'
import Dropdown from 'react-multilevel-dropdown'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import NoAccountsIcon from '@mui/icons-material/NoAccounts'
import ConfirmationModal from 'src/components/common/ConfirmationModal'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  EMPLOYEE_MANAGEMENT_HEADERS,
  GMC_LIST,
  GPA_LIST,
  GTL_LIST,
  NOTIFICATION_TYPES,
} from 'src/utils/constants/common'
import CustomPagination from 'src/components/common/custom-components/CustomPagination'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { showNotificationMessage } from 'src/actions'
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import { invokeAllTypesSXP } from 'src/services/individualService'
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded'
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded'
import {
  ACTIVE,
  ADD,
  ADD_GROUP_POLICIES,
  ADD_INITIATED,
  APPROVED_IMG,
  ARE_YOU_SURE_ASSIGNING_CEO_ROLE,
  ARE_YOU_SURE_TO_REVOKE_AS_ADMIN,
  ARE_YOU_SURE_TO_REVOKE_CEO_ROLE,
  ARE_YOU_SURE_TOASSIGN_AS_ADMIN,
  ASC,
  ASSIGN_CEO_ROLE,
  ASSIGN_CORP_ADMIN,
  DELETE,
  DELTE_INITIATED,
  DESC,
  DOWNLOAD_HEALTH_CARD,
  GMC,
  GPA,
  GTL,
  IN_ACTIVE,
  LOCATION_BASED,
  NO,
  REQUEST_APPROVE,
  REQUEST_REJECTED,
  REVOKE_CORP_ADMIN,
  REVOKE_ROLE,
  SELECT_EMPLOYEE_TO_DEL,
  UPDATE,
  UPDATE_INITIATED,
  YES,
} from 'src/utils/constants/Ceo'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'
import DateOfLeaving from 'src/components/ceo/EmployeeManagement/DateOfLeaving'
import { ADD_OR_DEL, IS_ADD } from 'src/utils/constants/EmployeeManagement'

const EmployeeManagement = ({
  clientId,
  clientType,
  isCompanyPolicy = false,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [order, setOrder] = useState('DESC')
  const [orderBy, setOrderBy] = useState('dateOfJoining')
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searched, setSearched] = useState('')
  const [searchedTemp, setSearchedTemp] = useState('')
  const [totalEmployeeRows, setTotalEmployeeRows] = useState([])
  const [addButtonEnable, setAddButtonEnable] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)

  const [assignCeoConfirmationModalOpen, setAssignCeoConfirmationModalOpen] =
    useState(false)
  const [revokeCeoConfirmationModalOpen, setRevokeCeoConfirmationModalOpen] =
    useState(false)
  const [ceoId, setCeoId] = useState('')

  const [
    assignCorporateAdminConfirmationModalOpen,
    setAssignCorporateAdminConfirmationModalOpen,
  ] = useState(false)
  const [
    revokeCorporateAdminConfirmationModalOpen,
    setRevokeCorporateAdminConfirmationModalOpen,
  ] = useState(false)
  const [corporateAdminId, setCorporateAdminId] = useState('')

  const filterType = LOCATION_BASED
  const [modalData, setModalData] = useState([])
  const [annexureType, setAnnexureType] = useState('')
  const [action, setAction] = useState('')
  const [selectedPersons, setSelectedPersons] = useState([])
  const [clientDetailsData, setClientDetailsData] = useState()
  const [modalType, setModalType] = useState('')

  let location = ''
  let branch = ''
  const submitSearch = () => {
    setSearched(searchedTemp)
  }
  const userInfo = useSelector((state) => state?.userInfo)
  const params = useParams()
  const history = useHistory()

  const openDeleteEmployeeModal = () => {
    setModalType(ADD_OR_DEL?.DELETE)
    setModalOpen(true)
  }

  const getUrl = () => {
    return 'dashboard/company/employeeManagement'
  }

  const getSelectedPolicies = () => {
    const selectedPolicySet = new Set()
    selectedPersons?.forEach((person) => {
      if (groupDetails(GMC_LIST, person?.policies) === YES) {
        selectedPolicySet?.add(GMC)
      }
      if (groupDetails(GTL_LIST, person?.policies) === YES) {
        selectedPolicySet?.add(GTL)
      }
      if (groupDetails(GPA_LIST, person?.policies) === YES) {
        selectedPolicySet?.add(GPA)
      }
    })

    return Array.from(selectedPolicySet)
  }

  const invokeSxpSingleAnnexure = (type, editUserData, employeeId) => {
    const selectedPersonIds = selectedPersons?.map((person) => person?.id)

    const sxpBody1 = {
      state: {
        clientId: getClientId(clientId, userInfo),
        clientType: getClientType(params?.clientType, userInfo),
        clientStatus: clientDetailsData?.clientStatus,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        email: userInfo?.userInfo?.userData?.emailId,
        roles: userInfo?.userInfo?.userData?.roles,
        deletionFolder: selectedPersonIds,
        editUserData: editUserData,
        editPolicy: handleEditPolicy(editUserData?.policies),
        deletePolicy: getSelectedPolicies(),
        selfEmployeeId: employeeId,
        isCompanyPolicy: isCompanyPolicy,
        clientTypeUrl: getClientTypeUrl(
          getClientType(params?.clientType, userInfo)
        ),
        url: getUrl(),
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpBody1, userInfo?.userName, type)
  }

  const {
    loading: singleAnnexureLoading,
    error: singleAnnexureError,
    data: singleAnnexureData,
    refetch,
  } = useQuery(
    SINGLE_ANNEXURE_DATA(
      getClientId(clientId, userInfo),
      searched,
      orderBy,
      page - 1,
      order,
      rowsPerPage
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
      variables: {
        page: page - 1,
        sortField: orderBy,
        sort: order,
        clientId: getClientId(clientId, userInfo),
        clientType: getClientType(params?.clientType, userInfo),
      },
    }
  )
  const {
    loading: portFolioListLoading,
    data: portFolioListData,
    error: portFolioListError,
  } = useQuery(
    PORTFOLIO_List_NEW(
      getClientId(clientId, userInfo),
      getClientType(clientType, userInfo)
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const {
    loading: linkAnnexureLoading,
    data: linkAnnexureData,
    error: linkAnnexureError,
  } = useQuery(
    LINK_ANNEXURE(
      getClientId(clientId, userInfo),
      filterType,
      location,
      branch
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  const [assignCEO, { data, loading: assignLoading }] = useMutation(
    ASSIGN_CEO(),
    {
      onError: () => {},
      onCompleted: () => {
        if (!data?.assignCorporateCEO?.success) {
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message: data?.assignCorporateCEO?.message,
            })
          )
        }
        toggleAssignConfirmationModal(false)
        toggleRevokeConfirmationModal(false)
      },
    }
  )

  const [
    assignCorporateAdmin,
    { data: corporateAdminData, loading: assignCorporateAdminLoading },
  ] = useMutation(ASSIGN_CORPORATE_ADMIN(), {
    onError: () => {},
    onCompleted: () => {
      if (!corporateAdminData?.assignAdminRoleToMember?.success) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: corporateAdminData?.assignAdminRoleToMember?.message,
          })
        )
      }
      toggleRevokeCorporatePOCConfirmationModal(false)
      toggleAssignCorporatePOCConfirmationModal(false)
      refetch()
    },
  })

  const fetchClientDetails = async () => {
    const response = await getClientDetails(getClientId(clientId, userInfo))
    try {
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      const clientDetailsResponse = response?.res?.data
      if (clientDetailsResponse) {
        setClientDetailsData(clientDetailsResponse?.[0])
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: clientDetailsResponse?.message,
          })
        )
      }
    } catch (err) {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  useEffect(() => {
    if (singleAnnexureData) {
      let employeeRowData =
        singleAnnexureData?.getSingleAnnexureData?.content ?? []
      employeeRowData = employeeRowData?.map((employeeData) => ({
        ...employeeData,
        isOpen: false,
      }))
      setTotalEmployeeRows([...employeeRowData])
    }

    if (portFolioListData) {
      if (
        portFolioListData?.getPortfolioV2?.data?.[0]?.companyPolicies
          ?.length === 0 &&
        portFolioListData?.getPortfolioV2?.data?.[1]?.companyPolicies
          ?.length === 0 &&
        portFolioListData?.getPortfolioV2?.data?.[2]?.companyPolicies
          ?.length === 0
      ) {
        setAddButtonEnable(false)
      }
    }
    if (linkAnnexureData) {
      setModalData(
        linkAnnexureData?.getAnnexurePolicyDetails?.locationData ?? []
      )
    }
  }, [singleAnnexureData, portFolioListData, linkAnnexureData])

  useEffect(() => {
    refetch({
      page: page,
      sortField: orderBy,
      sort: order,
    })
  }, [order, orderBy, refetch, page])

  useEffect(() => {
    fetchClientDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (modalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [modalOpen])

  if (singleAnnexureLoading || portFolioListLoading || linkAnnexureLoading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress id='loading' />
      </div>
    )
  }

  if (singleAnnexureError || portFolioListError || linkAnnexureError) {
    const errorData =
      singleAnnexureError || portFolioListError || linkAnnexureError
    return (
      <div>
        <GraphQlErrors error={errorData} data-test='graphql-error' />
      </div>
    )
  }

  const addEmployee = (linkAnnexure, action) => {
    setAnnexureType(linkAnnexure)
    setAction(action)
    setModalOpen(true)
    action === IS_ADD
      ? setModalType(ADD_OR_DEL?.ADD_EMPLOYEE)
      : setModalType(ADD_OR_DEL?.UPDATE)
  }

  const CloseModal = () => {
    setModalOpen(false)
    setSelectedPersons([])
  }

  const handleDownloadAnnexure = async () => {
    await getAnnexure(getClientId(clientId, userInfo))
  }

  const getViewEmployeeLink = (id) => {
    return `/individual/dashboard/company/employeeManagement/viewEmployee/${id}`
  }

  const navigateBack = () => {
    history.push('/individual/dashboard/company')
  }

  const tableToolbar = () => {
    const numSelected = selectedPersons?.length

    return (
      <div className={classes.toolbarContainer}>
        <Toolbar
          sx={{
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
            ...(numSelected > 0 && {
              bgcolor: (theme) =>
                alpha(
                  theme.palette.primary.main,
                  theme.palette.action.activatedOpacity
                ),
            }),
          }}
        >
          <Tooltip
            TransitionComponent={Zoom}
            placement='bottom'
            title={'Go Back'}
            arrow
          >
            <span onClick={navigateBack}>
              <img src={BackArrow} className={classes.image} alt={'back'} />
            </span>
          </Tooltip>

          <Typography
            flex='1 1 1%'
            variant='h6'
            id='tableTitle'
            component='div'
          >
            Employees List
          </Typography>

          <div className={classes.headingActionsContainer}>
            {/* <div>            // For Future use 
              {addButtonEnable ? (
                <Dropdown
                  title='Edit Employees'
                  isDisabled={!addButtonEnable}
                  id='editEmployeeButton'
                  className={classes.addEmployeeButton}
                  position='right'
                >
                  <Dropdown.Item>
                    Multiple Employees
                    <Dropdown.Submenu position='right'>
                      <Dropdown.Item>
                        <a
                          color='rgba(0, 0, 0, 0.87)'
                          href={`${process?.env?.REACT_APP_AWS_PUBLIC_IMAGES_LINK}/${process?.env?.REACT_APP_UPLOAD_EMPLOYEE_ANNEXURE_TEMPLATE}`}
                          download
                        >
                          Download
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          document.getElementById('editEmployeeButton')?.click()
                          addEmployee('multipleUpload', 'isEdit')
                        }}
                      >
                        Upload
                      </Dropdown.Item>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                </Dropdown>
              ) : (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={addButtonEnable === false ? ADD_GROUP_POLICIES : ''}
                  arrow
                >
                  <span>
                    <Button
                      disabled={!addButtonEnable}
                      id='editEmployeeButton'
                      className={`${classes.buttonUploadPersonal}`}
                    >
                      Edit Employee
                    </Button>
                  </span>
                </Tooltip>
              )}
            </div> */}

            <div>
              {addButtonEnable ? (
                <Dropdown
                  title='Add Employees'
                  isDisabled={!addButtonEnable}
                  id='addEmployeeButton'
                  className={classes.addEmployeeButton}
                  position='right'
                >
                  <Dropdown.Item>
                    Single Employee
                    <Dropdown.Submenu position='right'>
                      <Dropdown.Item
                        onClick={() => {
                          document.getElementById('addEmployeeButton')?.click()
                          addEmployee('singleAnnexure', 'isAdd')
                        }}
                      >
                        Add Employee
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          document.getElementById('addEmployeeButton')?.click()
                          addEmployee('addDependents', 'isAdd')
                        }}
                      >
                        Add Dependents
                      </Dropdown.Item>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    Multiple Employees
                    <Dropdown.Submenu position='right'>
                      <Dropdown.Item>
                        <a
                          color='rgba(0, 0, 0, 0.87)'
                          href={`${process?.env?.REACT_APP_AWS_PUBLIC_IMAGES_LINK}/${process?.env?.REACT_APP_UPLOAD_EMPLOYEE_ANNEXURE_TEMPLATE}`}
                          download
                        >
                          Download
                        </a>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          document.getElementById('addEmployeeButton')?.click()
                          addEmployee('multipleUpload', 'isAdd')
                        }}
                      >
                        Upload
                      </Dropdown.Item>
                    </Dropdown.Submenu>
                  </Dropdown.Item>
                </Dropdown>
              ) : (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={addButtonEnable === false ? ADD_GROUP_POLICIES : ''}
                  arrow
                >
                  <span>
                    <Button
                      disabled={!addButtonEnable}
                      id='addEmployeeButton'
                      className={`${classes.buttonUploadPersonal}`}
                    >
                      Add Employees
                    </Button>
                  </span>
                </Tooltip>
              )}
            </div>

            <Tooltip
              TransitionComponent={Zoom}
              placement='bottom'
              title={numSelected === 0 ? SELECT_EMPLOYEE_TO_DEL : ''}
              arrow
            >
              <span>
                <Button
                  onClick={() => {
                    openDeleteEmployeeModal()
                  }}
                  className={`${classes.buttonUploadPersonal} ${
                    classes.deleteButton
                  } ${!numSelected ? classes.deleteButtonDisabled : ''}`}
                  disabled={!numSelected}
                >
                  Delete Employees {numSelected}
                </Button>
              </span>
            </Tooltip>

            <SearchBar
              className={classes.searchBar}
              value={searchedTemp}
              autoFocus={true}
              placeholder={'Search'}
              onCancelSearch={() => setSearchedTemp('')}
              onChange={(newValue) => {
                setSearchedTemp(newValue)
              }}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  submitSearch()
                }
              }}
              id='searchBar'
              data-test='search-bar'
            />
          </div>
        </Toolbar>
      </div>
    )
  }

  const handleSortRequest = (cellId) => {
    const isDesc = orderBy === cellId && order === DESC
    setOrder(isDesc ? ASC : DESC)
    setOrderBy(cellId)
  }

  const handleCheckboxChange = (person) => {
    const selectedPesonIndex = selectedPersons?.findIndex(
      (personListItem) => personListItem?.id === person?.id
    )

    const tempSelectedData = JSON.parse(JSON.stringify(selectedPersons))

    if (selectedPesonIndex === -1) {
      tempSelectedData.push(person)
    } else {
      tempSelectedData?.splice(selectedPesonIndex, 1)
    }

    setSelectedPersons(tempSelectedData)
  }

  const handleEditPolicy = (policy) => {
    let editPolicy = []
    if (groupDetails(GMC_LIST, policy) === YES) {
      editPolicy.push(GMC)
    }
    if (groupDetails(GTL_LIST, policy) === YES) {
      editPolicy.push(GTL)
    }
    if (groupDetails(GPA_LIST, policy) === YES) {
      editPolicy.push(GPA)
    }
    return editPolicy
  }

  const handleChangePage = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (rows) => {
    setRowsPerPage(rows)
    setPage(1)
  }

  const isSelected = (id) => {
    return selectedPersons?.findIndex((person) => person?.id === id) !== -1
  }

  const groupDetails = (insuranceNameList, policyDetails) => {
    let finalState = NO
    policyDetails?.forEach((policy) => {
      if (insuranceNameList?.includes(policy?.insuranceType)) {
        finalState = YES
      }
    })
    return finalState
  }

  const employeeStatus = (policies, endorsements) => {
    if (endorsements?.length === 0) {
      if (
        groupDetails(GMC_LIST, policies) === NO &&
        groupDetails(GTL_LIST, policies) === NO &&
        groupDetails(GPA_LIST, policies) === NO
      ) {
        return (
          <Tooltip
            TransitionComponent={Zoom}
            placement='top'
            title={'Inactive'}
            arrow
          >
            <img
              src={cancelImg}
              className={classes.stateImage}
              alt={'cancelImg'}
            />
          </Tooltip>
        )
      } else {
        return (
          <Tooltip
            TransitionComponent={Zoom}
            placement='top'
            title={'Active'}
            arrow
          >
            <img
              src={ApprovedImg}
              className={classes.stateImage}
              alt={'ApprovedImg'}
            />
          </Tooltip>
        )
      }
    } else {
      if (endorsements?.[0]?.metadata?.action === DELETE) {
        if (endorsements?.[0]?.endorsementStatus === REQUEST_APPROVE) {
          if (
            groupDetails(GMC_LIST, policies) === NO &&
            groupDetails(GTL_LIST, policies) === NO &&
            groupDetails(GPA_LIST, policies) === NO
          ) {
            return (
              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={IN_ACTIVE}
                arrow
              >
                <img
                  src={cancelImg}
                  className={classes.stateImage}
                  alt={'cancelImg'}
                />
              </Tooltip>
            )
          } else {
            return (
              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={ACTIVE}
                arrow
              >
                <img
                  src={ApprovedImg}
                  className={classes.stateImage}
                  alt={APPROVED_IMG}
                />
              </Tooltip>
            )
          }
        } else {
          return (
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={DELTE_INITIATED}
              arrow
            >
              <img
                src={blueApprovedImg}
                className={classes.stateImage}
                alt={'blueApprovedImg'}
              />
            </Tooltip>
          )
        }
      } else if (endorsements?.[0]?.metadata?.action === ADD) {
        if (
          endorsements?.[0]?.endorsementStatus === REQUEST_APPROVE ||
          endorsements?.[0]?.endorsementStatus === REQUEST_REJECTED
        ) {
          if (
            groupDetails(GMC_LIST, policies) === NO &&
            groupDetails(GTL_LIST, policies) === NO &&
            groupDetails(GPA_LIST, policies) === NO
          ) {
            return (
              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={IN_ACTIVE}
                arrow
              >
                <img
                  src={cancelImg}
                  className={classes.stateImage}
                  alt={'cancelImg'}
                />
              </Tooltip>
            )
          } else {
            return (
              <Tooltip
                TransitionComponent={Zoom}
                placement='top'
                title={ACTIVE}
                arrow
              >
                <img
                  src={ApprovedImg}
                  className={classes.stateImage}
                  alt={'ApprovedImg'}
                />
              </Tooltip>
            )
          }
        } else {
          return (
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={ADD_INITIATED}
              arrow
            >
              <img
                src={blueApprovedImg}
                className={classes.stateImage}
                alt={'blueApprovedImg'}
              />
            </Tooltip>
          )
        }
      } else if (endorsements?.[0]?.metadata?.action === UPDATE) {
        if (endorsements?.[0]?.endorsementStatus === REQUEST_APPROVE) {
          return (
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={ACTIVE}
              arrow
            >
              <img
                src={ApprovedImg}
                className={classes.stateImage}
                alt={'ApprovedImg'}
              />
            </Tooltip>
          )
        } else {
          return (
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={UPDATE_INITIATED}
              arrow
            >
              <img
                src={blueApprovedImg}
                className={classes.stateImage}
                alt={'blueApprovedImg'}
              />
            </Tooltip>
          )
        }
      }
    }
  }

  const isInactiveEmployee = (row) => {
    return (
      employeeStatus(row?.policies, row?.endorsements)?.props?.title ===
      IN_ACTIVE
    )
  }

  const showDownload = (data) => {
    return data?.healthCards || data?.healthCardURL
  }

  const handleDocumentDownload = async (document, documentURL) => {
    await documentDownload(document ? document : [], documentURL)
  }

  const toggleDependentsView = (index) => {
    const employeeRowData = [...totalEmployeeRows]
    employeeRowData[index].isOpen = !employeeRowData[index]?.isOpen
    setTotalEmployeeRows([...employeeRowData])
  }

  const employeeRow = (row, isItemSelected, index) => {
    const { isCeo, isCorporatePoc } = row
    return (
      <>
        <TableRow
          sx={{ '& > *': { borderBottom: 'unset' } }}
          hover
          role='checkbox'
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={row?.id}
          selected={isItemSelected}
        >
          <TableCell>
            <Checkbox
              color='primary'
              checked={isItemSelected}
              disabled={isInactiveEmployee(row)}
              onClick={() => {
                handleCheckboxChange(row)
              }}
            />
          </TableCell>
          <TableCell component='th' scope='row'>
            {row?.empId}
          </TableCell>
          <TableCell align='left'>
            <Link to={getViewEmployeeLink(row?.id)} underline='always'>
              {row?.firstName ?? '-'}
            </Link>
          </TableCell>
          <TableCell align='left'>{row?.gender ?? ' -'}</TableCell>
          <TableCell align='left'>{row?.relation ?? '-'}</TableCell>
          <TableCell align='left' className={classes.dateCell}>
            {row?.dependents?.length ?? '-'} Dependents
            <IconButton
              aria-label='expand row'
              size='small'
              onClick={() => toggleDependentsView(index)}
            >
              {row?.isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell align='left' className={classes.dateCell}>
            {formatDate(row?.dateOfJoining)}
          </TableCell>
          <TableCell align='left' className={classes.dateCell}>
            {formatDate(row?.dateOfLeaving)}
          </TableCell>
          <TableCell align='left' className={classes.dateCell}>
            {formatDate(row?.dateOfBirth)}
          </TableCell>
          <TableCell align='left'> {formatToINR(row?.ctc) ?? '-'}</TableCell>
          <TableCell align='left'> {row?.location ?? '-'}</TableCell>
          <TableCell align='left'>{row?.mobileNumber ?? '-'}</TableCell>
          <TableCell align='left'>
            <Tooltip
              TransitionComponent={Zoom}
              placement='top'
              title={row?.email ?? '-'}
              arrow
            >
              <div className={classes.emailElipsize}>{row?.email ?? '-'}</div>
            </Tooltip>
          </TableCell>
          <TableCell align='left'>
            {groupDetails(GMC_LIST, row?.policies)}
          </TableCell>
          <TableCell align='left'>
            {groupDetails(GTL_LIST, row?.policies)}
          </TableCell>
          <TableCell align='left'>
            {groupDetails(GPA_LIST, row?.policies)}
          </TableCell>
          <TableCell align='left'>
            {employeeStatus(row?.policies, row?.endorsements)}
          </TableCell>
          <TableCell align='center'>
            <div className={classes.assignCEO}>
              <Tooltip
                TransitionComponent={Zoom}
                placement='bottom'
                title={'Edit'}
                arrow
              >
                <IconButton
                  onClick={() => {
                    invokeSxpSingleAnnexure('editAnnexure', row, row?.empId)
                  }}
                  disabled={isInactiveEmployee(row)}
                >
                  <EditRounded color='primary' />
                </IconButton>
              </Tooltip>

              {showDownload(row) ? (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={DOWNLOAD_HEALTH_CARD}
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      handleDocumentDownload(
                        row?.healthCards,
                        row?.healthCardURL
                      )
                    }}
                    disabled={isInactiveEmployee(row)}
                  >
                    <DownloadRounded color='primary' />
                  </IconButton>
                </Tooltip>
              ) : null}

              {!isCeo ? (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={ASSIGN_CEO_ROLE}
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      toggleAssignConfirmationModal(true, row?.id)
                    }}
                  >
                    <SupervisorAccountIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={REVOKE_ROLE}
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      toggleRevokeConfirmationModal(true, row?.id)
                    }}
                  >
                    <NoAccountsIcon />
                  </IconButton>
                </Tooltip>
              )}

              {!isCorporatePoc ? (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={ASSIGN_CORP_ADMIN}
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      toggleAssignCorporatePOCConfirmationModal(true, row?.id)
                    }}
                  >
                    <ManageAccountsRoundedIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip
                  TransitionComponent={Zoom}
                  placement='bottom'
                  title={REVOKE_CORP_ADMIN}
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      toggleRevokeCorporatePOCConfirmationModal(true, row?.id)
                    }}
                  >
                    <PersonOffRoundedIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tablecellStyles} colSpan={19}>
            <Collapse in={row.isOpen} timeout={'auto'} unmountOnExit>
              <Box margin={1}>
                <Table size='small' aria-label='collapsible table'>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align='left'>Emp ID</TableCell>
                      <TableCell align='left'>Name</TableCell>
                      <TableCell align='left'>Gender</TableCell>
                      <TableCell align='left'>Relation Type</TableCell>
                      <TableCell align='left'>Dependents</TableCell>
                      <TableCell align='left'>DOJ</TableCell>
                      <TableCell align='left'>DOB</TableCell>
                      <TableCell align='left'>CTC</TableCell>
                      <TableCell align='left'>City</TableCell>
                      <TableCell align='left'>Mobile</TableCell>
                      <TableCell align='left'>Email Id</TableCell>
                      <TableCell align='left'>GMC</TableCell>
                      <TableCell align='left'>GTL</TableCell>
                      <TableCell align='left'>GPA</TableCell>
                      <TableCell align='left'>Status</TableCell>
                      <TableCell align='left'>Edit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.dependents?.map((dependentRow, index) => {
                      const isItemSelectedChild = isSelected(dependentRow?.id)
                      return (
                        <TableRow key={dependentRow?.empId} left={'100px'}>
                          <TableCell padding='checkbox'>
                            <Checkbox
                              color='primary'
                              checked={isItemSelectedChild}
                              disabled={
                                employeeStatus(row?.policies, row?.endorsements)
                                  ?.props?.title !== IN_ACTIVE
                                  ? employeeStatus(
                                      row?.dependents?.[index]?.policies,
                                      row?.dependents?.[index]?.endorsements
                                    ).props.title === IN_ACTIVE
                                  : true
                              }
                              onClick={() => {
                                handleCheckboxChange(dependentRow)
                              }}
                            />
                          </TableCell>
                          <TableCell component='th' scope='row' align='left'>
                            {row?.empId}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.firstName ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.gender ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.relation ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.dependents?.length ?? '-'}
                          </TableCell>
                          <TableCell align='left'>{'-'}</TableCell>
                          <TableCell align='left'>
                            {formatDate(dependentRow?.dateOfBirth)}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.ctc ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.location ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.mobileNumber ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {dependentRow?.emailId ?? '-'}
                          </TableCell>
                          <TableCell align='left'>
                            {' '}
                            {groupDetails(
                              GMC_LIST,
                              row?.dependents?.[index]?.policies
                            )}
                          </TableCell>
                          <TableCell align='left'>{'-'}</TableCell>
                          <TableCell align='left'>{'-'}</TableCell>
                          <TableCell align='left'>
                            {isInactiveEmployee(row)
                              ? employeeStatus(row?.policies, row?.endorsements)
                              : employeeStatus(
                                  row?.dependents?.[index]?.policies,
                                  row?.dependents?.[index]?.endorsements
                                )}
                          </TableCell>
                          <TableCell align='center'>
                            <IconButton
                              cursor={'pointer'}
                              border={'none'}
                              backgroundColor={'white'}
                              onClick={() => {
                                invokeSxpSingleAnnexure(
                                  'editAnnexureDependent',
                                  row?.dependents?.[index],
                                  row?.empId
                                )
                              }}
                              disabled={
                                employeeStatus(row?.policies, row?.endorsements)
                                  ?.props?.title !== IN_ACTIVE
                                  ? employeeStatus(
                                      row?.dependents?.[index]?.policies,
                                      row?.dependents?.[index]?.endorsements
                                    )?.props?.title === IN_ACTIVE
                                  : true
                              }
                            >
                              <EditRounded color='primary' />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    )
  }

  const handleAssignCEO = () => {
    const deleteRole = false
    assignCEO({
      variables: {
        memberId: ceoId,
        deleteRole: deleteRole,
      },
    })
  }
  const handleRevokeCEO = () => {
    const deleteRole = true
    assignCEO({
      variables: {
        memberId: ceoId,
        deleteRole: deleteRole,
      },
    })
  }
  const closeAssignConfirmationModal = () => {
    setAssignCeoConfirmationModalOpen(false)
  }
  const closeRevokeConfirmationModal = () => {
    setRevokeCeoConfirmationModalOpen(false)
  }
  const toggleAssignConfirmationModal = (isConfirmationModalOpen, id) => {
    setAssignCeoConfirmationModalOpen(isConfirmationModalOpen)
    setCeoId(id)
  }
  const toggleRevokeConfirmationModal = (isConfirmationModalOpen, id) => {
    setRevokeCeoConfirmationModalOpen(isConfirmationModalOpen)
    setCeoId(id)
  }

  const handleAssignCorporatePOC = () => {
    const deleteRole = false
    assignCorporateAdmin({
      variables: {
        memberId: corporateAdminId,
        deleteRole: deleteRole,
      },
    })
  }

  const handleRevokeCorporatePOC = () => {
    const deleteRole = true
    assignCorporateAdmin({
      variables: {
        memberId: corporateAdminId,
        deleteRole: deleteRole,
      },
    })
  }

  const closeAssignCorporatePOCConfirmationModal = () => {
    setAssignCorporateAdminConfirmationModalOpen(false)
  }
  const closeRevokeCorporatePOCConfirmationModal = () => {
    setRevokeCorporateAdminConfirmationModalOpen(false)
  }
  const toggleAssignCorporatePOCConfirmationModal = (
    isConfirmationModalOpen,
    id
  ) => {
    setAssignCorporateAdminConfirmationModalOpen(isConfirmationModalOpen)
    setCorporateAdminId(id)
  }
  const toggleRevokeCorporatePOCConfirmationModal = (
    isConfirmationModalOpen,
    id
  ) => {
    setRevokeCorporateAdminConfirmationModalOpen(isConfirmationModalOpen)
    setCorporateAdminId(id)
  }

  const modalContent = () => {
    switch (modalType) {
      case ADD_OR_DEL?.ADD_EMPLOYEE:
      case ADD_OR_DEL?.UPDATE:
        return (
          <AddEmployeeModal
            closeFunction={CloseModal}
            dataLocation={modalData}
            action={action}
            annexureType={annexureType}
            clientDetails={clientDetailsData}
            isCompanyPolicy={true}
          />
        )
      case ADD_OR_DEL?.DELETE:
        return (
          <DateOfLeaving
            closeFunction={CloseModal}
            selectedPersons={selectedPersons}
            clientId={clientId}
            setSelectedPersons={setSelectedPersons}
            refetch={refetch}
          />
        )
      default:
        return null
    }
  }

  return (
    <Box className={classes.widthBox}>
      <LoadingModal
        id='loading'
        loading={assignLoading || assignCorporateAdminLoading}
      />
      {assignCeoConfirmationModalOpen && (
        <ConfirmationModal
          id='confirmationModal'
          message={ARE_YOU_SURE_ASSIGNING_CEO_ROLE}
          open={assignCeoConfirmationModalOpen}
          onClose={closeAssignConfirmationModal}
          onSubmit={handleAssignCEO}
        />
      )}
      {revokeCeoConfirmationModalOpen && (
        <ConfirmationModal
          id='confirmationModal'
          message={ARE_YOU_SURE_TO_REVOKE_CEO_ROLE}
          open={revokeCeoConfirmationModalOpen}
          onClose={closeRevokeConfirmationModal}
          onSubmit={handleRevokeCEO}
        />
      )}
      {assignCorporateAdminConfirmationModalOpen && (
        <ConfirmationModal
          id='assignCorporateAdminConfirmationModal'
          message={ARE_YOU_SURE_TOASSIGN_AS_ADMIN}
          open={assignCorporateAdminConfirmationModalOpen}
          onClose={closeAssignCorporatePOCConfirmationModal}
          onSubmit={handleAssignCorporatePOC}
        />
      )}
      {revokeCorporateAdminConfirmationModalOpen && (
        <ConfirmationModal
          id='revokeCorporateAdminConfirmationModal'
          message={ARE_YOU_SURE_TO_REVOKE_AS_ADMIN}
          open={revokeCorporateAdminConfirmationModalOpen}
          onClose={closeRevokeCorporatePOCConfirmationModal}
          onSubmit={handleRevokeCorporatePOC}
        />
      )}
      {modalOpen ? (
        <Modal
          ordered={modalOpen}
          width={'80%'}
          left={'10%'}
          top={'10%'}
          modelClosed={CloseModal}
        >
          {modalContent()}
        </Modal>
      ) : null}
      {tableToolbar()}
      <TableContainer component={Paper}>
        <Table aria-label='collapsible table'>
          <TableHead data-test='tableHeading'>
            <TableRow>
              <TableCell />
              {EMPLOYEE_MANAGEMENT_HEADERS?.map((headCell) => (
                <TableCell
                  align={
                    headCell?.id === 'empId' || headCell?.id === 'actions'
                      ? 'center'
                      : 'right'
                  }
                  key={headCell?.id}
                  sortDirection={orderBy === headCell?.id ? order : false}
                >
                  {headCell?.disableSorting ? (
                    headCell?.label
                  ) : (
                    <TableSortLabel
                      active={true}
                      direction={orderBy === headCell?.id ? order : 'asc'}
                      onClick={() => {
                        handleSortRequest(headCell?.id)
                      }}
                    >
                      {headCell?.label}
                    </TableSortLabel>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody data-test='employeeRowTableBody'>
            {totalEmployeeRows?.length ? (
              totalEmployeeRows?.map((row, index) => {
                const isItemSelected = isSelected(row?.id)
                return (
                  <React.Fragment key={`employeeRow__${row?.id}`}>
                    {employeeRow(row, isItemSelected, index)}
                  </React.Fragment>
                )
              })
            ) : (
              <TableRow>
                <TableCell colSpan={17} className='no-data-text'>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <>
        <Grid container className={classes.footer}>
          <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
            {totalEmployeeRows?.length ? (
              <CustomPagination
                totalCount={
                  singleAnnexureData?.getSingleAnnexureData?.pageInfo
                    ?.totalCount
                }
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                totalLabel={'Total Employees'}
              />
            ) : null}
          </Grid>
          <Grid>
            <Button
              className={classes.buttonListButton}
              onClick={handleDownloadAnnexure}
            >
              <span className={classes.downloadIcon}>
                <IconButton className={classes.downloadIconBtn}>
                  <DownloadRoundedIcon />
                </IconButton>
              </span>
              <span>Download Employee List</span>
            </Button>
          </Grid>
        </Grid>
      </>
    </Box>
  )
}

export default EmployeeManagement
const useStyles = makeStyles({
  toolbarContainer: { width: '100%' },
  addEmployeeButton: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.MEDIUM_LIGHTBLUE,
    color: COLORS.WHITE,
    margin: '0',
    height: '24px',
    padding: '15px !important',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_LIGHTBLUE,
    },
    display: 'flex',
    alignItems: 'center',
    borderColor: 'transparent',
    cursor: 'pointer',
  },
  buttonListButton: {
    textTransform: 'unset !important',
    fontSize: '11px !important',
    fontWeight: '600 !important',
    background: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    color: `${COLORS.WHITE} !important`,
    margin: '10px 0 !important',
    height: '24px !important',
    padding: '17px 15px !important',
    borderRadius: '10px !important',
    alignItems: 'center !important',
    '&:hover': {
      backgroundColor: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    },
  },
  downloadIconBtn: {
    color: '#ffffff !important',
    padding: '1px !important',
    margin: '2px',
    border: '1px solid #02A9F4 !important',
    ':hover': {
      border: '1px solid #ffffff !important',
    },
  },
  buttonUploadPersonal: {
    textTransform: 'unset !important',
    fontSize: '11px !important',
    fontWeight: '600 !important',
    background: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    color: `${COLORS.WHITE} !important`,
    margin: '0 !important',
    height: '24px !important',
    padding: '17px 15px !important',
    borderRadius: '10px !important',
    alignItems: 'center !important',
    '&:hover': {
      backgroundColor: `${COLORS.MEDIUM_LIGHTBLUE} !important`,
    },
  },
  searchBar: {
    border: '1px solid #112F3C',
    size: 'small',
    borderRadius: '9px',
    width: '30%',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    height: '25px',
    fontSize: '10px !important',
    boxShadow: 'none',
    '& .MuiSvgIcon-root': { width: '1em' },
  },
  depNoCell: { paddingRight: '0px !important', paddingLeft: '20px !important' },
  dob: {
    width: '15vw !important',
    fontSize: '12px !important',
    color: `${COLORS.MEDIUM_BLUE} !important`,
    paddingLeft: '10px',
    textAlign: 'center',
    '@media (min-width:1600px)': { fontSize: '14px !important' },
  },
  type1: {
    fontSize: '13px',
    paddingLeft: '30px',
    '@media (max-width:1550px)': {
      fontSize: '11px',
    },
  },
  typeGender: {
    fontWeight: '500 !important',
    fontSize: '13px',
    paddingLeft: '20px !important',
    '@media (max-width:1550px)': {
      fontSize: '11px',
    },
  },
  widthEmpId: {
    width: '60px !important',
  },
  widthName: {
    width: '120px !important',
    overflow: 'hidden',
  },

  widthGenderColumn: {
    width: '60px !important',
  },
  widthGender: {
    width: '60px !important',
  },
  widthRelationType: {
    width: '80px !important',
  },
  widthDependents: {
    width: '100px !important',
  },

  widthDate: { width: '60px !important' },
  widthCTCColumn: { width: '80px !important' },
  widthCTC: { width: '80px !important' },
  widthCityColumn: {
    width: '80px !important',
  },
  widthCity: {
    width: '80px !important',
  },
  widthMobile: { width: '70px !important' },
  widthEmail: { width: '220px !important' },
  widthType: { width: '30px !important' },
  widthStatus: { width: '50px !important' },
  widthEdit: { width: '50px !important' },
  widthTableContainer: {
    width: '1100px',
    '@media (min-width:1400px)': { width: '1284px' },
    '@media (min-width:1600px)': { width: '1500px' },
    '@media (min-width:1800px)': { width: '1500px' },
    '@media (min-width:2000px)': { width: '1500px' },
  },
  widthBox: {
    width: '95%',
    margin: 'auto',
    marginTop: '30px',
  },
  emailElipsize: {
    overflow: 'hidden !important',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis !important',
    display: 'inline-block',
    width: '60px !important',
  },
  stateImage: {
    width: '20px',
  },
  image: {
    paddingLeft: '5px',
    width: '21px',
    fontSize: '10px',
    paddingRight: '20px',
    marginTop: '10px',
    cursor: 'pointer',
  },
  loadingContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  assignCEO: {
    display: 'flex',
    flexDirection: 'row',
  },
  headingActionsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  deleteButton: {
    backgroundColor: '#B92250 !important',
    opacity: '0.8',
    color: 'white !important',
  },
  deleteButtonDisabled: {
    opacity: '0.2 !important',
  },
  footer: {
    justifyContent: 'space-between',
    marginBottom: '10px',
    padding: '10px 0',
  },
  tablecellStyles: {
    padding: '0px !important',
  },
  dateCell: {
    whiteSpace: 'nowrap',
  },
})
